/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as Actions from '../../actions/actions';

import { FormEditableInput } from '../elements/EditableInput';
import { FormCustomCheckbox } from '../elements/CustomCheckbox';
import FormDropdown from '../elements/Dropdown';
import Icon from '../icons/Icon';

import AboutUs from './shared/AboutUs';
import AsFeaturedIn from './shared/AsFeaturedIn';

import { HowItWorksContactContent } from '../../content/HowItWorksContent';

/* eslint max-len: 0 */
export class ContactDetailsPage extends Component {
    handleChange(event) {
        this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
        this.forceUpdate();
    }

    handleFormSubmit() {
        if (!this.props.canSubmit) {
            return;
        }

        browserHistory.push('message');
    }

    renderItems() {
        const iconDefaultSize = '60px';
        const style = { backgroundColor: '#F5F8FC' };

        const itemsRendered = [];
        for (let i = 0; i < HowItWorksContactContent.length; i++) {
            itemsRendered.push(
                <div className="app__grid__column__three-one padding-sides-20">
                    <div className="app__how-it-works__icon">
                        <Icon icon={ HowItWorksContactContent[i].icon } size={ iconDefaultSize } style={ style }/>
                    </div>
                    <div className="semi-bold">
                        <span className="semi-bold">{i + 1}. </span>{ HowItWorksContactContent[i].header }
                    </div>
                    <div className="app__how-it-works__info font-lighter">
                        { HowItWorksContactContent[i].text }
                    </div>
                </div>
            );
        }

        return itemsRendered;
    }

    renderHowItWorks() {
        return <div className="app__contact-page__how-it-works">
            <div className="how-it-works__container">
                <div className="app__how-it-works__list">
                    { this.renderItems() }
                </div>
            </div>
        </div>;
    }

    render() {
        const maxWidthInputs = '290px';
        const numberOfQuotesOptions = [
            { value: '1', text: 'One' },
            { value: '2', text: 'Two' },
            { value: '3', text: 'Three' },
        ];

        return (
            <div>
                { this.renderHowItWorks() }
                <div className="app__contact-page__container">
                    <div className="app__contact-page">
                        <FormEditableInput name="fullName"
                                           ref="fullName"
                                           label="Your full name"
                                           placeholder="Fred Smith"
                                           widthProportion="fixed"
                                           fixedWidth={ maxWidthInputs }
                                           value={ this.props.person.get('fullName') }
                                           handleChange={ this.handleChange.bind(this) }
                                           invalidSubmit={ this.props.invalidSubmit }
                                           required/>

                        <FormEditableInput name="email"
                                           ref="email"
                                           label="Your email"
                                           placeholder="fred@fs.com"
                                           validations="isEmail"
                                           validationError="This is not a valid email"
                                           value={ this.props.person.get('email') }
                                           handleChange={ this.handleChange.bind(this) }
                                           invalidSubmit={ this.props.invalidSubmit }
                                           widthProportion="fixed"
                                           fixedWidth={ maxWidthInputs }
                                           hintText="We'd like to send you a confirmation email and some tips on
                                                        getting the most from your adviser"
                                           required/>

                        <FormEditableInput name="phone"
                                           ref="phone"
                                           label="Your phone number"
                                           placeholder="01234 567 890"
                                           value={ this.props.person.get('phone') }
                                           maxLength={ 13 }
                                           invalidSubmit={ this.props.invalidSubmit }
                                           widthProportion="fixed"
                                           fixedWidth={ maxWidthInputs }
                                           handleChange={ this.handleChange.bind(this) }
                                           hintText="Most advisers will call you to discuss your request"
                                           required/>

                        <FormCustomCheckbox name="telephonyAdvice"
                                            label="I'm happy to speak to an adviser by phone only"
                                            value={ this.props.person.get('telephonyAdvice') }
                                            handleChange={ this.handleChange.bind(this) }/>

                        <FormEditableInput name="postcode"
                                           ref="postcode"
                                           label="Your postcode"
                                           placeholder="SW1A 0AA"
                                           value={ this.props.person.get('postcode') }
                                           maxLength={ 8 }
                                           invalidSubmit={ this.props.invalidSubmit }
                                           widthProportion="fixed"
                                           fixedWidth={ maxWidthInputs }
                                           handleChange={ this.handleChange.bind(this) }
                                           required/>

                        <FormDropdown name="numberOfQuotes"
                                      ref="numberOfQuotes"
                                      label="How many quotes would you like?"
                                      value={ this.props.person.get('numberOfQuotes') }
                                      options={ numberOfQuotesOptions }
                                      widthProportion="fixed"
                                      fixedWidth={ maxWidthInputs }
                                      handleChange={ this.handleChange.bind(this) } />

                        <div className="inline-block text-align-center push-up-5">
                            <div className="app__form-page__security-message">
                                <div className="app__form-page__security-message__icon">
                                    <Icon icon="lock" size="22px" style={ { fill: 'white' } }/>
                                </div>
                                <div>
                                    You are protected by SSL security. We go above and beyond industry standards
                                    to ensure your data is safe
                                </div>
                            </div>
                        </div>

                        <div className="text-align-center push-up-10">
                            <button className="big-button vouchedfor-brand mobile-button" refs="next" name="next"
                                    onClick={ this.handleFormSubmit.bind(this) }>
                                Get Free IFA Quotes
                            </button>
                        </div>
                    </div>
                </div>

                <AsFeaturedIn/>
                <AboutUs/>

            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        invalidSubmit: state.navigation.get('invalidSubmit'),
        canSubmit: state.navigation.get('canSubmit'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetailsPage);



// WEBPACK FOOTER //
// ./src/components/steps/ContactDetailsPage.jsx